<div mat-dialog-title>
    <h1 class="dialog-title">Claim Attachment</h1>
</div>
<div mat-dialog-content class="d-flex flex-column dialog-content">
    <div>
        <span class="text-muted">File Name: </span>{{ data.document.fileName }}
    </div>
    <div class="justify-content-start mt-2 dialog-title-detail">
        <div class="d-flex flex-column mt-1">
            <mat-label>Description</mat-label>
            <mat-form-field appearance="fill">
                <textarea class="comment-input" rows="10" matInput [(ngModel)]="description"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="justify-content-center">
        <div *ngIf="data.isImage; else fileContainer">
            <div *ngIf="loadingImage; else imageContainer">
                <mat-spinner></mat-spinner>
            </div>
            <ng-template #imageContainer>
                <img [src]="imageSource" width="100%" height="auto">
            </ng-template>
        </div>
        <ng-template #fileContainer>
            <div class="d-flex justify-content-center file-container">
                <mat-icon class="file-icon">insert_drive_file</mat-icon>
            </div>
        </ng-template>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="action-button" (click)="onSaveClick()">Save</button>
    <button mat-raised-button class="warn-button" (click)="onDeleteClick()">Delete</button>
    <button mat-raised-button [mat-dialog-close]="{ action: 'close' }">Close</button>
</div>